import { ButtonComp, CardComp } from "../../../../components";

const BalanceCard = ({
  used,
  total,
  btnText,
  title,
  onClickAction = () => {},
  progressBgColor,
  progressBarColor,
  image,
  unlimited = false,
  /** When true, show only remaining balance (same as dashboard) — no "X/Y" or allocation */
  showRemainingOnly = false,
}) => {
  const percentage = unlimited
    ? "100%"
    : total > 0
    ? `${Math.min(100, (used / total) * 100)}%`
    : "0%";

  return (
    <CardComp
      cardClassName={"pt-4"}
      cardBodyClassName={
        "py-0 d-flex justify-content-between align-items-center w-100 px-1"
      }
    >
      <div className="d-flex align-items-center gap-2">
        <div className="">{image && <img src={image} alt={title} />}</div>
        <article>
          <p className="mb-0 h5">
            {unlimited ? (
              <span className="fw-bold">Unlimited</span>
            ) : showRemainingOnly ? (
              <span className="fw-bold">{used}</span>
            ) : (
              <>
                <span className="fw-bold">{used}/</span>
                <span className="text-blacklight">{total}</span>
              </>
            )}
          </p>
          <p className="mb-0 opacity-50">
            <small>{title}</small>
          </p>
          {!showRemainingOnly && (
            <div
              className="progress"
              style={{
                height: "10px",
                width: "190px",
                backgroundColor: progressBgColor,
              }}
            >
              <div
                className="progress-bar"
                role="progressbar"
                aria-label={unlimited ? "Unlimited" : "Balance"}
                style={{
                  width: percentage,
                  background: progressBarColor,
                }}
                aria-valuenow={unlimited ? 100 : Math.min(100, total > 0 ? (used / total) * 100 : 0)}
                aria-valuemin="0"
                aria-valuemax="100"
              />
            </div>
          )}
        </article>
      </div>
      {btnText && (
        <ButtonComp
          btnClassName={"px-4 py-2 text-white bg-primary1 rounded"}
          btnText={btnText}
          onClick={onClickAction}
        />
      )}
    </CardComp>
  );
};

export const DeliveryCard = ({ title, image, figure }) => {
  return (
    <CardComp
      cardClassName={"pt-4"}
      cardBodyClassName={"py-0 d-flex align-items-center gap-2"}
    >
      <div className="">{image && <img src={image} alt={title} />}</div>
      <article>
        <p className="mb-0 opacity-50">
          <small>{title}</small>
        </p>
        <p className="mb-0 h5">{figure}</p>
      </article>
    </CardComp>
  );
};

export default BalanceCard;
